import { BILLING_STATUS } from 'src/features/servicePlanBillingPolicies/utils/types';
import { CURRENCY } from 'src/types';

export enum PAYMENT_TYPE {
    PRE = 'pre',
    POST = 'post',
}

export enum PRICING_MODEL {
    FLAT = 'flat',
    PER_UNIT = 'per_unit',
}

/**
 * A policy is priced either by a fixed `amount` or by a percentage of a reference rate - never both,
 * never neither. This drives the form's mode toggle and is not part of the API payload.
 */
export enum PRICING_MODE {
    FIXED = 'fixed',
    INDEXED = 'indexed',
}

/** The rate a policy is indexed to, nested one level in read responses. */
export type PricingPolicyReferenceRate = {
    id: string;
    name: string;
    code: string;
    currency: CURRENCY;
};

export type ServicePlanItemPricingPolicy = {
    id: string;
    tax_reason: {
        id: string;
        name: string | null;
    };
    status: BILLING_STATUS;
    version_number: number;
    created_at: string;
    modified_at: string;
    valid_from: string;
    payment_type: PAYMENT_TYPE;
    /** Minor units. Null when the policy is indexed to a reference rate instead. */
    amount: number | null;
    reference_rate: PricingPolicyReferenceRate | null;
    /** A decimal fraction - "0.5" means 50%. Set together with `reference_rate`. */
    rate_multiplier: string | null;
    valid_to: string | null;
    pricing_model: PRICING_MODEL;
    free_quantities: number | null;
    currency?: CURRENCY;
};
